import { render, staticRenderFns } from "./ResearchDetail.vue?vue&type=template&id=453b5ea9&scoped=true&"
import script from "./ResearchDetail.vue?vue&type=script&lang=ts&"
export * from "./ResearchDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453b5ea9",
  null
  
)

export default component.exports